import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

// const emptyMisc = {
//     files:[],
// }

const initialState = {
  misc: []
}

export const misc_doc = createSlice({
  name: 'misc_doc',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    initializeMiscDoc: () => {
      return { ...initialState }
    },
    addMiscDoc: state => {
      state.misc.push({
        files: []
      })
      return state
    },
    addMiscDocData: (state, action) => {
      return {
        ...state,
        misc: [...(Array.isArray(state.misc) ? state.misc : []), action.payload]
      }
    },
    removeMiscDoc: (state, action) => {
      state.misc.splice(action.payload.no, 1)
      return state
    },
    addMiscDocFile: (state, action) => {
      state.misc[action.payload.no].files.push({})
      return state
    },
    removeMiscDocFile: (state, action) => {
      var no = action.payload.no
      var file_no = action.payload.file_no
      state.misc[no].files.splice(file_no, 1)
      return state
    },
    removeMiscDocData: (state, action) => {
      let { file_obj } = action.payload.item
      const updatedArr = state.misc.filter(
        item => item?.file_obj?.id !== file_obj?.id
      )

      return {
        ...state,
        misc: updatedArr
      }
    },
    setMiscDocFile: (state, action) => {
      state.misc[action.payload.no].files[action.payload.file_no] = {
        file_obj: action.payload.file_obj,
        base64: action.payload.base64
      }

      return state
    },
    setMiscDocFileWithData: (state, action) => {
      const { no, file } = action.payload

      // Ensure the misc document exists
      if (!state.misc[no]) {
        state.misc[no] = { files: [] }
      }

      // Ensure the files array exists
      if (!state.misc[no].files) {
        state.misc[no].files = []
      }

      state.misc[no].files.push(file)
      return state
    },
    setMiscDocFileWithDoc: (state, action) => {
      state.misc[action.payload.no] = action.payload.file
      return state
    },
    setMiscFiles: (state, action) => {
      state.misc = action.payload.files
      return state
    },
    setMiscImage: (state, action) => {
      const { id } = action.payload
      const itemIndex = state.misc.findIndex((_, idx) => idx === id?.idx)

      if (itemIndex !== -1 && id) {
        if (!state.misc[itemIndex]?.document_revision_id)
          state.misc[itemIndex] = {
            ...state.misc[itemIndex],
            ...id?.file
          }
      }
    },
    deleteMiscImage: (state, action) => {
      const { id } = action.payload

      const itemIndex = state.misc.findIndex(item => item.id === id)
      if (itemIndex !== -1) {
        state.misc[itemIndex] = { id }
      }
    },
    deleteMiscFile: (state, action) => {
      const { id = '' } = action.payload
      const updatedFiles = state.misc.filter(file => file.id !== id)
      return {
        ...state,
        misc: updatedFiles
      }
    },
    setMiscDocumentsFromAPI: (state, action) => {
      state.misc = action.payload
      return state
    }
  }
})

export const {
  setMiscImage,
  deleteMiscImage,
  deleteMiscFile,
  initializeMiscDoc,
  addMiscDoc,
  addMiscDocData,
  removeMiscDoc,
  addMiscDocFile,
  removeMiscDocFile,
  removeMiscDocData,
  setMiscDocFile,
  setMiscDocFileWithData,
  setMiscDocFileWithDoc,
  setMiscFiles,
  setMiscDocumentsFromAPI
} = misc_doc.actions

export default misc_doc.reducer
